import BriefApplicationButton from 'features/briefs/components/molecules/BriefApplicationButton/BriefApplicationButton';

export default BriefApplicationButton;
